import { Outlet } from "react-router-dom";
import Navbar from "@/components/public/Navbar";
import Footer from "@/components/public/Footer";
import ScrollProgress from "@/components/public/ScrollProgress";

export default function PublicLayout() {
  return (
    <div className="min-h-screen bg-sunset-bg">
      <ScrollProgress />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
